export default "__VITE_ASSET__quLXyIWC__"